import { AxiosHeaders } from 'axios';
import {
  buildKeyGenerator,
  CacheOptions,
  CacheRequestConfig,
} from 'axios-cache-interceptor';

const CACHE_TTL_FIVE_MIN = 5 * 60 * 1000;
const CACHE_TTL_FORTY_FIVE_SEC = 45 * 1000;

const getHeader = (headers: CacheRequestConfig['headers'], name: string) =>
  AxiosHeaders.from(headers as AxiosHeaders).get(name);

export const AXIOS_CACHE_CONFIG: CacheOptions = {
  enabled: false,
  generateKey: buildKeyGenerator(
    ({ baseURL, url, method, params, data, headers }) => ({
      baseURL,
      url,
      method,
      params,
      data,
      platform: getHeader(headers, 'Platform'),
      language: getHeader(headers, 'Language'),
      country: getHeader(headers, 'Country'),
      acceptLanguage: getHeader(headers, 'Accept-Language'),
    })
  ),
};

const FIVE_MINUTE_CACHE_CONFIG = {
  enabled: true,
  ttl: CACHE_TTL_FIVE_MIN,
  interpretHeader: false,
};

export const FIVE_MINUTE_GET_CACHE_CONFIG: CacheRequestConfig = {
  cache: FIVE_MINUTE_CACHE_CONFIG,
};

export const FIVE_MINUTE_POST_CACHE_CONFIG: CacheRequestConfig = {
  cache: {
    ...FIVE_MINUTE_CACHE_CONFIG,
    methods: ['post'],
  },
};

export const FORTY_FIVE_SECOND_POST_CACHE_CONFIG: CacheRequestConfig = {
  cache: {
    enabled: true,
    ttl: CACHE_TTL_FORTY_FIVE_SEC,
    interpretHeader: false,
    methods: ['post'],
  },
};
